import { FaCircleCheck, FaTriangleExclamation, FaXmark } from "react-icons/fa6";

export const StokBadgeLogistic = ({ stok, minStock = 0, size = "md" }) => {
    const sizeClass = size === "lg" ? "px-4 py-1.5 text-sm" : "px-3 py-1 text-xs";
    if (stok === 0) {
      return (
        <span className={`inline-flex items-center gap-2 rounded-full font-bold ${sizeClass} bg-red-500/15 text-red-400 border border-red-500/25`}>
          <FaXmark size={size === "lg" ? 14 : 10} />
          HABIS
        </span>
      );
    }
    if (stok < minStock) {
      return (
        <span className={`inline-flex items-center gap-2 rounded-full font-bold ${sizeClass} bg-red-500/10 text-red-400 border border-red-500/20`}>
          <FaTriangleExclamation size={size === "lg" ? 14 : 10} />
          {stok}
        </span>
      );
    }
    return (
      <span className={`inline-flex items-center gap-2 rounded-full font-semibold ${sizeClass} bg-emerald-500/10 text-emerald-400 border border-emerald-500/20`}>
        <FaCircleCheck size={size === "lg" ? 14 : 10} />
        {stok}
      </span>
    );
  };